import React from "react";
import styles from "../FinanceDetailV2.module.scss";

// Pastille du type de carburant du véhicule du devis. Rien si non renseigné.
const FuelBadge = ({ quotationObj }) => {
  const fuel = quotationObj?.vehicle?.brandModelFinish?.fuelType?.name;
  if (!fuel) return null;
  return <span className={styles.fuelBadge}>{fuel}</span>;
};

export default FuelBadge;
